module.exports = __webpack_public_path__ + "fonts/f66f9fa82c52babcd0e31b4fc3d10064.txt";